<template>
    <div class="page printpage" :class="pageClass()">

        <dropzone-file-upload v-model="inputs.fileSingle"></dropzone-file-upload>
        <!-- dropzone-file-upload v-model="inputs.fileSingle" v-on:addedfile="addedfile"></dropzone-file-upload -->

    </div>
</template>
<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import moment from 'moment'
import AppStyle from '@/plugins/appStyle';

import DropzoneFileUpload from '@/components/Inputs/DropzoneFileUpload'
import { integer } from 'vee-validate/dist/rules';


export default {
    name: 'photo-book-page',
    mixins: [AppStyle.Mixin],
    components: {
        DropzoneFileUpload,
    },
    data() {
        return {
            loading: true,
            inputs: {
                fileSingle: '',
            },
            photoBookPage: null,
            photoBookPageImage: null,
            showOptions: false,
        }
    },
    props: {
        photoBookId: integer,
        token: String,
    },
    methods: {
        retrievePhotoBookPage() {
            this.loading = true;
            this.$api.getPhotoBookPage(this.photoBookId, this.token)
                .then((response) => {
                    console.log(response.data);
                    this.photoBookPage = response.data;
                })
                .catch((e) => {
                    console.log(e);
                }).finally(() => {
                    this.loading = false;
                    // this.toggleAllRows();
                });
        },
        toggleOptions() {
            if (this.showOptions) {
                this.showOptions = false;
            }
            else {
                this.showOptions = true;
            }
        },
        handleOrientationSet() {
        },
        pageClass() {
            return this.currentPhotoBook.orientation;
        },
    },
    channels: {
        ClaimsChannel: {
            connected() {
                //console.log('I am connected to claims');
            },
            rejected() {
                //console.log('I am REJECTED.');
            },
            received(data) {
                //        console.log("RECEIVED!");
                //        console.log(data);
                // switch case if documents_generated
                // switch case if documents_signed
                // do something on receive... check if docs generated
                if (data.action == "signed") {
                    this.claim.attachments = data.payload;
                    this.claim.documents_signed = true;
                }

                if (data.action == "generated") {
                    this.claim.attachments = data.payload;
                    this.claim.documents_generated = true;
                }
            },
            disconnected() {
                console.log('I am disconnected.');
            },
        }
    },
    computed: {
        ...mapGetters({
            currentAccount: 'currentAccount',
            currentSettings: 'currentSettings',
            currentPhotoBook: 'currentPhotoBook',
        }),
        ...mapActions({
            fetchPhotoBook: 'fetchPhotoBook',
        }),
        midWidth() {
            let w = 12;
            if (this.showImagelist) {
                w -= 2;
            }
            if (this.showOptions) {
                w -= 2;
            }
            console.log(w);
            return w;
        },
        maxPageDimension(){
            return 0;
        },
    },
    mounted() {
        this.retrievePhotoBookPage();
    },
    created() {
    },
}
</script>
<style scoped>
.landscape {
    width: 297mm;
    height: 210mm;
}

.portrait {
    height: 297mm;
    width: 210mm;
}

.page_framed {
    background-size: contain;
    background-repeat: no-repeat;
    padding: 1cm;
}

.page_contain {
    background-size: contain;
    background-repeat: no-repeat;
}

.page_cover {
    background-size: cover;
}

.printpage {
    background-size: contain;
    background-repeat: no-repeat;
}

.page {
    background: white;
    display: block;
    margin: 0 auto;
    margin-bottom: 0.5cm;
    box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
}

.flipbook-bg {
  width: 90vw;
  height: 90vh;
}

@import url("https://book.sardo.work/dist/docs/css/vue-booklet.7fec6b73ee5925cf3df34307b1a868e4.css");
</style>